<div class="p-5 pb-0">
    <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>REPORTES</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="formReportes">
                <div class="flex flex-row pt-5">
                    <mat-form-field class="w-1/2 mr-5">
                        <mat-label>Tipo de reporte</mat-label>
                        <mat-select formControlName="tipo">
                            @for (item of catTipo; track item.id) {
                                <mat-option [value]="item.id">{{ item.descripcion }}</mat-option>
                            }
                        </mat-select>
                        @if(formReportes.controls["tipo"].hasError('required')) {
                            <mat-error>Campo obligatorio.</mat-error>
                        }
                    </mat-form-field>
                    <div class="w-1/2 mr-5"></div>
                </div>
                <div>
                    <h2 class="!pl-1 !mb-0">
                        &nbsp;
                        @if(formReportes.controls['tipo'].value == 1) { Fecha de Envío }
                        @if(formReportes.controls['tipo'].value == 2) { Fecha de Envío }
                        @if(formReportes.controls['tipo'].value == 4) { Fecha Creación del Entregable }
                        @if(formReportes.controls['tipo'].value == 5) { Fecha Inicio de Entrada }
                    </h2>
                </div>
                @if(formReportes.get('tipo')?.value != 0 && formReportes.get('tipo')?.value != 3) {
                    <div class="flex flex-row pt-5 pb-5">
                        <mat-form-field class="w-1/2 mr-5">
                            <mat-label>Fecha Desde</mat-label>
                            <input matInput [matDatepicker]="pickerDesde" [max]="moment().toDate()" formControlName="fechaInicio">
                            <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                            <mat-datepicker-toggle matIconSuffix [for]="pickerDesde"></mat-datepicker-toggle>
                            <mat-datepicker #pickerDesde></mat-datepicker>
                            @if(formReportes.controls["fechaInicio"].hasError('required')) {
                                <mat-error>Campo obligatorio.</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field class="w-1/2 mr-5">
                            <mat-label>Fecha Hasta</mat-label>
                            <input matInput [matDatepicker]="pickerHasta" [min]="formReportes.value.fechaInicio" formControlName="fechaFin">
                            <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                            <mat-datepicker-toggle matIconSuffix [for]="pickerHasta"></mat-datepicker-toggle>
                            <mat-datepicker #pickerHasta></mat-datepicker>
                            @if(formReportes.controls["fechaFin"].hasError('required')) {
                                <mat-error>Campo obligatorio.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
            </form>
        </mat-card-content>
        <mat-card-footer class="flex flex-row justify-end p-4">
            <button type="button" mat-flat-button color="primary mr-5" (click)="consultaReporte()" [disabled]="formReportes.invalid">CONSULTAR</button>
            <button type="button" mat-stroked-button color="primary" (click)="descargaReporte()" [disabled]="formReportes.invalid">DESCARGAR</button>
        </mat-card-footer>
    </mat-card>
</div>

@if(showReport) {
    <mat-card class="m-5" appearance="outlined">
        <mat-card-header>
        <mat-card-title *ngIf="showReport">{{ tipoReporte.toUpperCase() }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <h3 class="text-center" *ngIf="sinResultados">No se encontraron coincidencias</h3>
            <mat-selection-list>
                @for (item of rows[1]; track item.id) {
                    <mat-list-item lines="6">
                        <span matListItemLine (click)="verEntrada(item)"><b>Fecha de Envío a BB:</b> {{ item.fecha_string | date:'dd/MM/yyyy' }}   </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Enviado por:   </b> {{ item.enviado_descripcion.split("|")[0] }}                </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Empresa:       </b> {{ item.empresa_descripcion }}                </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Tipo:          </b> {{ item.entrada_tipo_descripcion }}           </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Asunto:        </b> {{ item.asunto }}                             </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Leido:         </b> {{ item.leido == 'true'? 'SI' : 'NO' }}                
                            @if (item.leido == 'true') {
                                <span matListItemLine (click)="verEntrada(item)"><b>Fecha de Leído: </b> {{ item.leido_fecha }} </span>
                                <span matListItemLine (click)="verEntrada(item)"><b>Hora de Leído:  </b> {{ item.leido_hora }}  </span>
                            }
                        </span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                }

                @for (item of rows[2]; track item.id) {
                    <mat-list-item lines="7">
                        <span matListItemLine (click)="verEntrada(item)"><b>Fecha de Envío:</b> {{ item.fecha_string | date:'dd/MM/yyyy' }}   </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Enviado por:   </b> {{ item.enviado_descripcion.split("|")[0] }}                </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Empresa:       </b> {{ item.empresa_descripcion }}                </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Tipo:          </b> {{ item.entrada_tipo_descripcion }}           </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Asunto:        </b> {{ item.asunto }}                             </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Leido:         </b> {{ item.leido == 'true'? 'SI' : 'NO' }}                
                            @if (item.leido == 'true') {
                                <span matListItemLine (click)="verEntrada(item)"><b>Fecha de Leído: </b> {{ item.leido_fecha }} </span>
                                <span matListItemLine (click)="verEntrada(item)"><b>Hora de Leído:  </b> {{ item.leido_hora }}  </span>
                            }
                        </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Medio:         </b> {{ item.tipo_descripcion }}                   </span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                }

                @for (item of rows[3]; track item.id) {
                    <mat-list-item lines="9">
                        <span matListItemLine (click)="verEntrada(item)"><b>Número:                 </b> {{ $index + 1 }}                                       </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Empresa:                </b> {{ item.empresa }}                     </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Asunto:                 </b> {{ item.asunto }}                                  </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Enviado a:              </b> {{ item.remitente_enviado_descripcion }}           </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Sin Respuesta:          </b> {{ item.contador }}                                </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Sin Respuesta Usuario:  </b> {{ item.faltantes_usuarios }}                      </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Fecha Inicio:           </b> {{ item.fechaInicio_string | date:'dd/MM/yyyy' }}  </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Fecha Fin:              </b> {{ item.fechaFin_string | date:'dd/MM/yyyy' }}     </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Estatus:                </b> 
                            {{ 
                                item.estatus == 'Terminado'? 'Terminado' : 
                                    item.idEstatus == 1 ? 'A tiempo' :
                                        item.idEstatus == 2 ? 'Por vencer' : 'Vencido'
                            }}
                        </span>
                        <mat-icon matListItemIcon class="mt-5" [style]="(item.idEstatus == 1)? 'color:#339f2c' : (item.idEstatus == 2)? 'color:#ffb300': 'color:#c00006'">
                            {{
                                item.idEstatus == 1? 'thumb_up' :
                                    (item.idEstatus == 2)? 'thumbs_up_down' :
                                        'thumb_down'
                            }}
                        </mat-icon>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                }

                @for (item of rows[4]; track item.id) {
                    <mat-list-item lines="9">
                        <span matListItemLine (click)="verEntrada(item)"><b>Número:                                     </b> {{ $index + 1 }}                                    </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Usuario Analista:                           </b> {{ item.analista_descripcion.split("|")[0] }}       </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Usuario Supervisor:                         </b> {{ item.supervisor_descripcion.split("|")[0] }}     </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Usuario Coordinador:                        </b> {{ item.coordinador_descripcion.split("|")[0] }}    </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Asunto:                                     </b> {{ item.asunto }}                                   </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Tipo Entregable:                            </b> {{ item.tipo_descripcion }}                         </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Fecha y hora de creación del entregable:    </b> {{ item.fechaInicio_string | date:'dd/MM/yyyy HH:mm:ss' }}   </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Estatus del Entregable:                     </b> {{ item.estatus_descripcion }}                      </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Estatus fecha y hora:                       </b> {{ item.terminado_string | date:'dd/MM/yyyy HH:mm:ss' }}     </span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                }

                @for (item of rows[5]; track item.id) {
                    <mat-list-item lines="4">
                        <span matListItemLine (click)="verEntrada(item)"><b>ID Sobre:               </b> {{ item.idSobre }}                            </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Asunto:                 </b> {{ item.asunto }}                             </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Fecha Inicio de Entrada:</b> {{ item.fecha_string | date:'dd/MM/yyyy' }}   </span>
                        <span matListItemLine (click)="verEntrada(item)"><b>Remitente:              </b> {{ item.remitente.split("|")[0] }}                           </span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                }
            </mat-selection-list>
        </mat-card-content>
    </mat-card>
}